import { useState } from "react";
import MainLayout from "../../components/layout/layout";
import {
  LabelText,
  LargeHeadline,
  MediumText,
  SubTitle,
} from "../../components/typography";
import Input from "../../components/ui/inputs";
import { BodyBlock, ItemsSpan } from "./sign-in";
import { Button } from "../../components/ui/button";
import { COLORS } from "../../assets/utils/enums/colors";
import arrowLeft from "../../assets/images/icons/arrow-left.svg";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useAuthValidation } from "../../assets/utils/hooks/useAuthValidation";
import { AuthModeEnum } from "../../assets/utils/validation/types";
import breakpoints from "../../assets/styles/breakpoint";
import CustomToast from "../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import { API_URL_AUTH } from "../../constants";
import { useDispatch } from "react-redux";
import { setResetEmail } from "../../assets/store/reset-password";

export default function ForgotPassword() {
  const [email, setEmail] = useState<string>("");
  const [loaderState, setLoaderState] = useState<boolean>(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { errors, validate } = useAuthValidation();

  async function forgotPassword() {
    try {
      setLoaderState(true);
      const { hasErrors } = validate({ email }, AuthModeEnum.FORGOT);
      if (hasErrors) return;

      const response = await fetch(`${API_URL_AUTH}/send-code`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
        credentials: "include",
      });

      if (!response.ok) {
        const text = await response.text();
        toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.ERROR}
            text={text.split("\n")[0].split("System.Exception:")[1]?.trim() || "Помилка вводу"}
          />
        ));
        return;
      }

      dispatch(setResetEmail(email));
      navigate('/enter-code');
    } catch (error) {
      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.ERROR}
          text={"Упс, щось пішло не так\nПроблеми з сервером."}
        />
      ));
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 1000);
    }
  }

  return (
    <MainLayout
      className="d-flex flex-column align-items-center"
      loaderState={loaderState}
    >
      <BodyBlock>
        <LargeHeadline>Забули пароль?</LargeHeadline>
        <SubTitle>
          Ми надішлимо Вам код на електронну адресу для відновлення
          паролю.{" "}
        </SubTitle>
        <Input
          attribute="email"
          value={email}
          setValue={setEmail}
          errorText={errors?.email}
          label="Електронна пошта"
          placeholder="Example@gmail.com"
        />
        <Button
          bgcolor={COLORS.blue}
          txtcolor={COLORS.white}
          brcolor={"transparent"}
          type="large"
          width="100%"
          onClick={forgotPassword}
        >
          <LabelText>Надіслати</LabelText>
        </Button>
        <ActionSpan className="w-100 d-flex align-items-center justify-content-between px-0">
          <Button
            bgcolor={"transparent"}
            txtcolor={COLORS.secondary1}
            brcolor={"transparent"}
            type="large"
            width="auto"
            className="d-flex align-items-center gap-2"
            onClick={() => navigate("/sign-in")}
          >
            <img src={arrowLeft} alt="arrow-left" />
            <MediumText>Повернутися назад</MediumText>
          </Button>
          <Button
            bgcolor={"transparent"}
            txtcolor={COLORS.blue}
            brcolor={"transparent"}
            type="large"
            width="auto"
            onClick={forgotPassword}
          >
            <MediumText>Надіслати знову</MediumText>
          </Button>
        </ActionSpan>
      </BodyBlock>
    </MainLayout>
  );
}

const ActionSpan = styled(ItemsSpan)`
  ${breakpoints.md} {
  }
`;
